var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'tsyringe';
import localforage from 'localforage';
import { localDatabaseKey } from '../dto/input/LocalDatabase';
let LocalDatabaseDataSource = class LocalDatabaseDataSource {
    async save(key, value) {
        try {
            return await localforage.setItem(localDatabaseKey[key], value);
        }
        catch (e) {
            console.error(e);
            throw e;
        }
    }
    async load(key) {
        try {
            return await localforage.getItem(localDatabaseKey[key]);
        }
        catch (e) {
            console.error(e);
            throw e;
        }
    }
    async remove(key) {
        try {
            await localforage.removeItem(localDatabaseKey[key]);
        }
        catch (e) {
            console.error(e);
            throw e;
        }
    }
};
LocalDatabaseDataSource = __decorate([
    injectable()
], LocalDatabaseDataSource);
export { LocalDatabaseDataSource };
